module.exports = "/_next/static/images/9b56f967acaa83be1c8cc74570b69372-woman-with-yellow-glasses@1x.jpg.webp";